export default {
  loadFont () {
    let link = document.createElement('link')
    link.href = `https://fonts.googleapis.com/css?family=Raleway:100,300,400`
    link.rel = 'stylesheet'

    document.head.appendChild(link)
    document.oncopy = function(){
      return true;
    }


      jQuery("#addVoice").prepend(
        '<'+'audio id="Audio" loop'+'>'+
        '<'+'source src="images/20ji-dtb-0525.wav" type="audio/wav"'+'>'+
        '<'+'source src="images/20ji-dtb-0525.mp3" type="audio/mpeg"'+'>'+
        '<'+'/audio'+'>'
      )

    $('.carousel').carousel({
      pause: false,
      interval: 10000
    })
    $('#fullpage').fullpage({
      scrollOverflow: true,
      responsiveWidth: 1300,
    })

    var iconVolume = document.getElementsByClassName('icon-volume')[0]
    var oAudio = document.getElementById('Audio')
    var backTop = document.getElementById('backTop')
    var awardNextPage = document.getElementsByClassName('award-next-page')[0]

    oAudio.volume = 0.2

    awardNextPage.onclick = function() {
      fullpage_api.moveTo(2);
    }
    backTop.onclick = function() {
      fullpage_api.moveTo(1);
    }

    iconVolume.onclick = function() {
      if (iconVolume.classList.contains('icon-volume-off')) {
        iconVolume.classList.add('icon-volume-up')
        iconVolume.classList.remove('icon-volume-off')
        oAudio.play()
      } else {
        iconVolume.classList.add('icon-volume-off')
        iconVolume.classList.remove('icon-volume-up')
        oAudio.pause()
      }
    }

    // $('.change-img').slick({
    //   dots: false,
    //   infinite: true,
    //   pauseOnHover: false,
    //   arrows: false,
    //   speed: 500,
    //   fade: true,
    //   autoplay: true,
    //   autoplaySpeed: 3000,
    //   cssEase: 'linear'
    // });

  }
}
